import useAudio from './useAudio';

export default useAudio;
